import { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PublicTicketBooking from "./pages/PublicTicketBooking";
import PublicTicketBookingQr from "./pages/publicTicketBookingQr";
import CenterRegistration from "./pages/CenterRegistration";
import Technicians from "./pages/Technicians";
import Tickets from "./pages/Admin/Tickets";
import Login from "./pages/login";
import Centers from "./pages/Admin/Centers";
import Home from "./components/NavBar/Home";
import Reopen from "./pages/Admin/Reopen";
import AddTechnician from "./pages/AddTechnician";
import AddTicket from "./pages/AddTicket";
import AdminTechnician from "./pages/Admin/technician";
import AdminLogin from "./pages/Admin/adminLogin";
import PrivateRoute from "./helper/privateRoute";
import PublicRoute from "./helper/publicRoute";
import AdminPrivateRoute from "./helper/privateRouteAdmin";
import AdminPublicRoute from "./helper/adminPublicRoute";
import CenterOnboardRoute from "./helper/privateRouteCenterOnboarding";
import AddClientTicket from "./pages/Admin/AddClientTicket";
import TicketsCenter from "./pages/ticketCenter";
import CenterDashboard from "./pages/CenterDashboard";
import BroadCastedRequests from "./pages/broadcastedRequests";
import TicketCreatedByYou from "./pages/ticketCreatedByYou";
import CenterTicket from "./pages/Admin/CenterTicket";
import NavBar from "./components/NavBar/navbar";
import AdminNavBar from "./components/NavBar/adminPannel";
import CenterOnboardNavBar from "./components/NavBar/CenterOnboardNavbar";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import BroadcastTickets from "./pages/Admin/BroadcastTickets";
import AdminClients from "./pages/Admin/AdminClients";
import AdminRoles from "./pages/Admin/Roles/AdminRoles";
import CloseTicket from "./pages/Admin/CloseTicket";
import NoSerTickets from "./pages/Admin/NoSerTickets";
import Reportpage from "./pages/Admin/reportpage";
import PendingTickets from "./pages/Admin/PendingTickets";
import AddTicketAdmin from "./pages/Admin/AddNewTicket";
import AdminBroadCastList from "./pages/Admin/broadcastedList";
import AdminAddCenter from "./pages/Admin/AddCenter";
import Dashboard from "./pages/Admin/Dashboard";
import Wallet_client from "./pages/Admin/Wallet_client";
import PaymentsList from "./pages/payments";
import ViewTicketPage from "./pages/Admin/veiwTicket";
import ForgotPassword from "./pages/Admin/ForgotPassword";
import FeedBackComponent from "./pages/feedBack";
import AdminFeedBack from "./pages/Admin/FeedBack";
import AddRole from "./pages/Admin/Roles/AddRole";
import AdminUsers from "./pages/Admin/Users/AdminUsers";
import AddUser from "./pages/Admin/Users/AddUser";
import AdminCenterOnboarders from "./pages/Admin/AdminCenterOnboarders/AdminCenterOnboarders";
import AddCenterOnboarder from "./pages/Admin/AdminCenterOnboarders/AddCenterOnboarder";
import Notifications from "./components/Components/Notifications";
import CenterOnboardRegistration from "./pages/CenterOnboarding/CenterOnboardRegistration";
import CenterOnboardLogin from "./pages/CenterOnboarding/CenterOnboardLogin";
import CenterOnboardAddCenter from "./pages/CenterOnboarding/components/CenterOnboardAddCenter";
import CenterOnboardViewCenters from "./pages/CenterOnboarding/components/CentersList";
import ServiceStatus from "./components/ServicesStatus/ServiceStatus";
import EditCenter from "./pages/Admin/EditCenter";
import WalletHistory from "./pages/Admin/PaymentDetails/WalletHistory";
import PaymentHistory from "./pages/Admin/PaymentDetails/PaymentTransacion";
import UserDetailsTable from "./pages/Admin/Users/UserTable";
import TechnicianDocView from "./components/AdminApi/TechnicianDocView";
import TicketDocView from "./components/AdminApi/TicketDocView";
import CenterHistory from "./pages/Admin/CenterHistory";
import PublicPickDropQr from "./pages/PublicPickDropQr";
import ERickshawTicket from "./pages/Admin/ERickshawTicket";
import NotificationLog from "./components/Components/NotificationLog";
import AllClientTickets from "./pages/Admin/AllClientTickets";
import Banner from "./pages/Admin/Banner";
import Offers from "./pages/Admin/Offers";
import Subscription from "./pages/Admin/Subscription";
import Blog from "./pages/Admin/Blog/blog";
import ViewCenter from "./pages/Admin/viewCenter";
import ClientPrivateRoute from "./helper/ClientPrivateRoute";
import ClientDashboard from "./pages/Client/ClientDashboard";
import ClientNavBar from "./components/NavBar/clientPannel";
import ClientRequests from "./pages/Client/clientRequests";
import ClientLogin from "./pages/Client/ClientLogin";
import ClientProfile from "./pages/Client/ClientDashboard";
import ClientServiceCategory from "./pages/Client/ClientServiceCategory";
import PaymentHistoryClient from "./pages/Client/PaymentHistory";
import ClientReport from "./pages/Client/ClientReport";
import PublicTicketBookingClientQr from "./pages/PublicTicketBookingClientQr";
import AddClientTicketById from "./pages/Client/AddClientTicketById";
import ClientLayout from "./components/NavBar/ClientLayout";
import BookingWrapper from "./pages/BookingWrapper";
import PartRequest from "./pages/Client/PartRequest";
import PullbackPage from "./pages/Admin/PullBack/PullbackPage";

const stylesSheet = {
  styleForDiv: {
    marginTop: "6%",
    marginLeft: "18%",
    marginRight: "3%",
  },
};

const AppRoutes = () => (
  <Suspense>
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Navigate to="/booking" replace />} />
      <Route path="/serviceStatus" element={<ServiceStatus />} />
      <Route
        path="/registration/:centerOnboarderId?"
        element={<CenterRegistration />}
      />
      <Route path="/feedback/:id" element={<FeedBackComponent />} />
      <Route path="/booking/:id" element={<BookingWrapper />} />
      <Route path="/bookingPickDrop/:id" element={<PublicPickDropQr />} />
      <Route path="/booking" element={<PublicTicketBooking />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/client-login" element={<ClientLogin />} />
      <Route
        path="/center-onboard-registration"
        element={<CenterOnboardRegistration />}
      />
      <Route path="/center-onboard-login" element={<CenterOnboardLogin />} />

      {/* Client Routes */}
      <Route
        path="/client-profile"
        element={
          <ClientPrivateRoute>
            <ClientLayout>
              <ClientProfile />
            </ClientLayout>
          </ClientPrivateRoute>
        }
      />
      <Route
        path="/client-requests"
        element={
          <ClientPrivateRoute>
            <ClientLayout>
              <ClientRequests />
            </ClientLayout>
          </ClientPrivateRoute>
        }
      />
      <Route
        path="/client-service-category"
        element={
          <ClientPrivateRoute>
            <ClientLayout>
              <ClientServiceCategory />
            </ClientLayout>
          </ClientPrivateRoute>
        }
      />
      <Route
        path="/add-client-request-by-id"
        element={
          <ClientPrivateRoute>
            <ClientLayout>
              <AddClientTicketById />
            </ClientLayout>
          </ClientPrivateRoute>
        }
      />
      <Route
        path="/payment-history"
        element={
          <ClientPrivateRoute>
            <ClientLayout>
              <PaymentHistoryClient />
            </ClientLayout>
          </ClientPrivateRoute>
        }
      />
      <Route
        path="/part-request"
        element={
          <ClientPrivateRoute>
            <ClientLayout>
              <PartRequest />
            </ClientLayout>
          </ClientPrivateRoute>
        }
      />
      <Route
        path="/client-report"
        element={
          <ClientPrivateRoute>
            <ClientLayout>
              <ClientReport />
            </ClientLayout>
          </ClientPrivateRoute>
        }
      />

      {/* Center Routes */}
      <Route
        path="/center-dashboard"
        element={
          <PrivateRoute>
            <>
              <NavBar />
              <div style={stylesSheet.styleForDiv}>
                <CenterDashboard />
              </div>
            </>
          </PrivateRoute>
        }
      />
      <Route
        path="/Technicians"
        element={
          <PrivateRoute>
            <>
              <NavBar />
              <div style={stylesSheet.styleForDiv}>
                <Technicians />
              </div>
            </>
          </PrivateRoute>
        }
      />
      <Route
        path="/brodcast-requests"
        element={
          <PrivateRoute>
            <>
              <NavBar />
              <div style={stylesSheet.styleForDiv}>
                <BroadCastedRequests />
              </div>
            </>
          </PrivateRoute>
        }
      />
      <Route
        path="/payments"
        element={
          <PrivateRoute>
            <>
              <NavBar />
              <div style={stylesSheet.styleForDiv}>
                <PaymentsList />
              </div>
            </>
          </PrivateRoute>
        }
      />
      <Route
        path="/AddTechnician"
        element={
          <PrivateRoute>
            <>
              <NavBar />
              <div style={stylesSheet.styleForDiv}>
                <AddTechnician />
              </div>
            </>
          </PrivateRoute>
        }
      />
      <Route
        path="/AddTicket"
        element={
          <PrivateRoute>
            <>
              <NavBar />
              <div style={stylesSheet.styleForDiv}>
                <AddTicket />
              </div>
            </>
          </PrivateRoute>
        }
      />
      <Route
        path="/ticket-created-by-you"
        element={
          <PrivateRoute>
            <>
              <NavBar />
              <div style={stylesSheet.styleForDiv}>
                <TicketCreatedByYou />
              </div>
            </>
          </PrivateRoute>
        }
      />
      <Route
        path="/tickets-center"
        element={
          <PrivateRoute>
            <>
              <NavBar />
              <div style={stylesSheet.styleForDiv}>
                <TicketsCenter />
              </div>
            </>
          </PrivateRoute>
        }
      />

      {/* Admin Routes */}
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route
        path="/admin-dashboard"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AdminDashboard />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/client-dashboard"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <Dashboard />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/center-history/:centerId"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <CenterHistory />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/reopen-log/:id"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <Reopen />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/wallet-client"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <Wallet_client />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/broad-casted-list"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AdminBroadCastList />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/add-center"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AdminAddCenter />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/view-ticket"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <ViewTicketPage />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/usersdetails"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <UserDetailsTable />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/wallet"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <WalletHistory />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/payment"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <PaymentHistory />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/edit-center"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <EditCenter />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/admin-centers"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <Centers />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/view-center/:centerId"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <ViewCenter />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/admin-ticket"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AddTicketAdmin />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/admin-feedBack"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AdminFeedBack />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/Tickets"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <Tickets />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/pending-ticket"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <PendingTickets />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/erickshaw-ticket"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <ERickshawTicket />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/notification-history"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <NotificationLog />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/close-ticket"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <CloseTicket />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/noService-ticket"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <NoSerTickets />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/center-ticket"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <CenterTicket />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/all-client-ticket"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AllClientTickets />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/add-client-ticket"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AddClientTicket />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/report-page"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <Reportpage />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/admin-technician"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AdminTechnician />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/admin-broadcast-tickets"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <BroadcastTickets />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/admin-clients"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AdminClients />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/roles"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AdminRoles />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/add-role"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AddRole />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/users"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AdminUsers />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <Notifications />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/add-user"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AddUser />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/admin-center-onboarders"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AdminCenterOnboarders />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/admin-add-center-onboarder"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <AddCenterOnboarder />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/blog"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <Blog />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/banner"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <Banner />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/offers"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <Offers />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/subscription"
        element={
          <AdminPrivateRoute>
            <>
              <AdminNavBar />
              <div style={stylesSheet.styleForDiv}>
                <Subscription />
              </div>
            </>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/pullback"
        element={
          <AdminPrivateRoute>
            <AdminNavBar />
            <div style={stylesSheet.styleForDiv}>
              <PullbackPage />
            </div>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/tecnicianDocument"
        element={
          <AdminPrivateRoute>
            <TechnicianDocView />
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/ticketDocument"
        element={
          <AdminPrivateRoute>
            <AdminNavBar />
            <div style={stylesSheet.styleForDiv}>
              <TicketDocView />
            </div>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/Home"
        element={
          <AdminPrivateRoute>
            <Home />
          </AdminPrivateRoute>
        }
      />

      {/* Center Onboard Routes */}
      <Route
        path="/center-onboard-add-center"
        element={
          <CenterOnboardRoute>
            <>
              <CenterOnboardNavBar />
              <div style={stylesSheet.styleForDiv}>
                <CenterOnboardAddCenter />
              </div>
            </>
          </CenterOnboardRoute>
        }
      />
      <Route
        path="/center-onboard-view-centers"
        element={
          <CenterOnboardRoute>
            <>
              <CenterOnboardNavBar />
              <div style={stylesSheet.styleForDiv}>
                <CenterOnboardViewCenters />
              </div>
            </>
          </CenterOnboardRoute>
        }
      />
    </Routes>
  </Suspense>
);

export default AppRoutes;
